export function formatArrayNames(values: string[]) {
  let title = ''
  title = values.length > 5 ? `${values.slice(0, 5).join(', ')}, ${values.length - 5}+` : values.join(', ')
  return title || ''
}
